// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"12ec5637","777":"8d26f87f","813":"63e1f886"}[chunkId] + ".chunk.css";
};